import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NzUploadFile } from "ng-zorro-antd/upload";
import { Subject } from "rxjs";

import { environment } from "../../../environments/environment";
import { SignatureService } from "../interceptor/signature";

/**
 * 阿里云 FC Http Trigger 调用示例代码
 * 1. 参数 url 为配置文件中 function 的 url
 * 2. 参数 body 为请求体
 * 3. 参数 queries 为请求 url 中的 query parameters
 *    备注: 编写阿里云 FC 如果使用 path parameters 传值, 如果没有 query parameters, 则需要给一个 query parameter, 否则签名认证失败
 * this.common.post(`/test/post`, {}, { id: "62739b67ffbbaa47ae8f8256" }).subscribe(
 *   (res) => {
 *     console.log(res);
 *   },
 *   (err) => {
 *     console.log(err);
 *   }
 * );
 */
@Injectable({
  providedIn: "root",
})
export class CommonService {
  private readonly serviceName: string;
  private readonly functionName: string;

  selectedItem$ = new Subject();
  selectedItem = [];
  orders$ = new Subject();
  items$ = new Subject();
  categories$ = new Subject();
  brands$ = new Subject();

  constructor(private http: HttpClient, private signature: SignatureService) {
    this.serviceName = environment.aliyun.serviceName;
    this.functionName = environment.aliyun.functionName;
  }

  private buildUrl(url: string, serviceName?: string, functionName?: string) {
    if (!url.startsWith("/")) {
      url = `/${url}`;
    }


    console.log("environment.local =" + environment.local);

    if (environment.local) {
      return `http://192.168.1.4:7001${url}`;
      // return `http://127.0.0.1:7001${url}`;
    }

    const _endpoint = this.signature.getProxyURL();
    const _serviceName = serviceName || this.serviceName;
    const _functionName = functionName || this.functionName;

    return `${_endpoint}/${_serviceName}/${_functionName}${url}`;
  }

  readBase64(file: NzUploadFile): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve({ base64: reader.result, filename: file.name });
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsDataURL(file as any);
    });
  }

  get(url: string, queries?: any, serviceName?: string, functionName?: string) {
    const _url = this.buildUrl(url, serviceName, functionName);
    const _options = {};

    if (queries && Object.keys(queries).length > 0) {
      _options["params"] = queries;
    } else {
      _options["params"] = { 1: "1" }; // 解决只有 path parameters 无法通过签名认证的情况
    }

    return this.http.get(_url, _options);
  }

  post(
    url: string,
    body: any,
    queries?: any,
    serviceName?: string,
    functionName?: string
  ) {
    const _url = this.buildUrl(url, serviceName, functionName);
    const _body = body || {};
    const _options = {};

    if (queries && Object.keys(queries).length > 0) {
      _options["params"] = queries;
    } else {
      _options["params"] = { 1: "1" }; // 解决只有 path parameters 无法通过签名认证的情况
    }

    return this.http.post(_url, _body, _options);
  }

  put(
    url: string,
    body: any,
    queries?: any,
    serviceName?: string,
    functionName?: string
  ) {
    const _url = this.buildUrl(url, serviceName, functionName);
    const _body = body || {};
    const _options = {};

    if (queries && Object.keys(queries).length > 0) {
      _options["params"] = queries;
    } else {
      _options["params"] = { 1: "1" }; // 解决只有 path parameters 无法通过签名认证的情况
    }

    return this.http.put(_url, _body, _options);
  }

  delete(
    url: string,
    queries?: any,
    serviceName?: string,
    functionName?: string
  ) {
    const _url = this.buildUrl(url, serviceName, functionName);
    const _options = {};

    if (queries && Object.keys(queries).length > 0) {
      _options["params"] = queries;
    } else {
      _options["params"] = { 1: "1" }; // 解决只有 path parameters 无法通过签名认证的情况
    }

    return this.http.delete(_url, _options);
  }
}
